import { CraftingResources } from '@components/arsenal/forge/CraftingResources';
import { EquipmentDisplay } from '@components/helpers/EquipmentDisplay';
import { CraftingTimer } from '@components/arsenal/forge/CraftingTimer';
import { WeaponInfo } from '@components/arsenal/weapons/WeaponInfo';
import { capitalize } from '@helpers/dotNotation';
import { Modal } from '@components/ui/Modal';
import * as Shared from '@shared/lib';
import { useState } from 'react';

interface WeaponCraftingProps {
  weapon: string;
  finishesAt?: string;
}

export function WeaponCrafting({ weapon, finishesAt }: WeaponCraftingProps) {
  const [showInfo, setShowInfo] = useState(false);

  const data = Shared.weaponsData.find((c) => c.key === weapon);
  if (!data) return null;

  const crafting = data.crafting;

  return (
    <>
      <Modal
        onRequestClose={() => setShowInfo(false)}
        title={capitalize(data.key)}
        isOpen={showInfo}
      >
        <WeaponInfo weapon={data.key} />
      </Modal>

      <EquipmentDisplay onClick={() => setShowInfo(true)} value={data.key} type="WEAPON">
        {finishesAt && <CraftingTimer duration={crafting.duration} finishesAt={finishesAt} />}
        {!finishesAt && <CraftingResources crafting={crafting} />}
      </EquipmentDisplay>
    </>
  );
}